var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.modalData.showModal ? _c('BaseModal', {
    on: {
      "close": function close($event) {
        _vm.modalData.showModal = false;
      }
    }
  }, [_c('CourseEditAttendanceModal', {
    attrs: {
      "headline": _vm.modalData.modalHeadline,
      "modalType": _vm.modalData.modalType,
      "attendanceParticipant": _vm.modalData.existingItem
    },
    on: {
      "close": function close($event) {
        _vm.modalData.showModal = false;
      },
      "updateCourseParticipant": _vm.registerSingleAttendance
    }
  })], 1) : _vm._e(), _c('BaseLayout', {
    staticClass: "px-0",
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('v-icon', {
          attrs: {
            "left": ""
          },
          on: {
            "click": _vm.navigateToAttendanceList
          }
        }, [_vm._v("mdi-arrow-left")]), _vm._v(" " + _vm._s(_vm.$route.params.id) + " - " + _vm._s(_vm.course.courseName) + " ")];
      },
      proxy: true
    }, {
      key: "actions",
      fn: function fn() {
        return [_c('v-text-field', {
          staticClass: "mr-5",
          attrs: {
            "append-icon": "mdi-magnify",
            "label": "Søk",
            "single-line": "",
            "hide-details": ""
          },
          model: {
            value: _vm.search,
            callback: function callback($$v) {
              _vm.search = $$v;
            },
            expression: "search"
          }
        }), _c('v-btn', {
          attrs: {
            "disabled": !_vm.showRegisterButton,
            "color": "white",
            "outlined": "",
            "data-cy": "batchRegisterAttendance"
          },
          on: {
            "click": _vm.batchRegisterAttendance
          }
        }, [_c('v-icon', {
          attrs: {
            "left": ""
          }
        }, [_vm._v("mdi-plus")]), _vm._v(" Registrer fremmøte ")], 1)];
      },
      proxy: true
    }])
  }, [[_c('BaseTableFiltered', {
    staticClass: "mt-3",
    attrs: {
      "item-key": "userId",
      "data-cy": "attendanceParticipantTable",
      "headers": _vm.headers,
      "items": _vm.attendances,
      "items-per-page": 50,
      "scrollable": false,
      "search": _vm.search,
      "show-select": ""
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('div', {
          staticClass: "subtitle-1 font-weight-light align-self"
        }, [_vm._v(" Dato: "), _c('strong', [_vm._v(" " + _vm._s(_vm.getFormattedDateTime) + " ")])])];
      },
      proxy: true
    }, {
      key: "item.noOfHours",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.isRegistered ? item.noOfHours || "Ikke møtt" : item.noOfHours || "Avventer registrering") + " ")];
      }
    }, {
      key: "item.isRegistered",
      fn: function fn(_ref2) {
        var value = _ref2.value;
        return [_vm._v(" " + _vm._s(value ? "Registrert" : "Ikke registrert") + " ")];
      }
    }, {
      key: "item.updatedByUserFullName",
      fn: function fn(_ref3) {
        var value = _ref3.value;
        return [_vm._v(" " + _vm._s(value || "-") + " ")];
      }
    }, {
      key: "item.updated",
      fn: function fn(_ref4) {
        var value = _ref4.value;
        return [_vm._v(" " + _vm._s(value ? _vm.formatDate(value) : "-") + " ")];
      }
    }, !_vm.isCourseDone ? {
      key: "actions",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref6) {
              var on = _ref6.on,
                  attrs = _ref6.attrs;
              return [_c('v-icon', _vm._g(_vm._b({
                attrs: {
                  "data-cy": "editAttendanceParticipant"
                },
                on: {
                  "click": function click($event) {
                    return _vm.openAttendanceParticipantModal(item);
                  }
                }
              }, 'v-icon', attrs, false), on), [_vm._v(" mdi-pencil ")])];
            }
          }], null, true)
        }, [_c('span', [_vm._v("Rediger fremmøte")])]), item.isRegistered ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref7) {
              var on = _ref7.on,
                  attrs = _ref7.attrs;
              return [_c('v-icon', _vm._g(_vm._b({
                attrs: {
                  "data-cy": "deleteAttendanceParticipant"
                },
                on: {
                  "click": function click($event) {
                    return _vm.deleteCourseParticipantAttendance(item);
                  }
                }
              }, 'v-icon', attrs, false), on), [_vm._v(" mdi-delete ")])];
            }
          }], null, true)
        }, [_c('span', [_vm._v("Slett fremmøte")])]) : _vm._e()];
      }
    } : null], null, true),
    model: {
      value: _vm.selectedAttendances,
      callback: function callback($$v) {
        _vm.selectedAttendances = $$v;
      },
      expression: "selectedAttendances"
    }
  })]], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }